import "./card.css"

import Accordion from 'react-bootstrap/Accordion';

import { HiOutlineExternalLink } from "react-icons/hi";
import { Link } from "react-router-dom";

export default function  Card(Props) {
  let data = encodeURI(Props.title);
  function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
  }
  data = replaceAll(data,"/",".");
    return(
        <Accordion className="card_item" flush >
        <Accordion.Item eventKey="0">
          <hr className="hr_item"/>
          <Accordion.Header>
            {Props.title}
            </Accordion.Header>
          <Accordion.Body>
            {Props.desc}
            <br />
            <br />
            <div className="secnav__learnmore">
              <Link to={{ 
                pathname:"/info/"+data,
                state:{stateParam:true}
              }} style={{ textDecoration: "none", color: "#000" }} key={Props.desc} >
                Learn More <HiOutlineExternalLink color="#000" size={20} />
              </Link>
            </div>
          </Accordion.Body>
          {/* <hr  className="hr_item"/> */}
        </Accordion.Item>
      </Accordion>
    );
    
}